module.exports = __webpack_public_path__ + "img/duracion_cortos.9b58fe6d.png";